const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  variantUnavailable: 'variant-unavailable',
  cartError: 'cart-error',
  addToCartSuccess: 'add-to-cart-success',
  addToCartSuccessSilent: 'add-to-cart-success-silent',
  cartUpdateSuccess: 'cart-update-success',
  atcAnimationComplete: 'atc-animation-complete',
  openQuickAdd: 'open-quick-add',
  closeQuickAdd: 'close-quick-add',
};
